import React from 'react'

import { connect } from "react-redux";
import { SetDepositPayments_LB } from '$Deposits/store/actions/DepositPost'
import { numberWithCommas } from '$Deposits/lib/LibCommonData'
import { DepositHeader } from '../index'
import { SetDepositDateSelect, SetDepositTimeSelect, SetUploadFileErr, PostUploadFile, PostMemberCancelDeposit } from '$Deposits/store/actions/DepositAction'
import TipsView from '../Components/TipsView'
import CopyView from '../Components/CopyView'
import SubmitBtn from '../Components/SubmitBtn'
import UploadFile from '../Components/UploadFile'
import html2canvas from 'html2canvas';
const download = require('downloadjs');
import NextStepCon from '$Deposits/Components/QD/NextStep'
import Modal from '../Components/Modal'
import { GetParamsData } from '$Deposits/lib/LibCommonData'



class NextStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
        this._viewShotRef = null
    }

    componentDidMount() {

    }
    componentWillUnmount() {

    }

    //下載分享圖片
    downloadShareImage = async () => {
        html2canvas(document.querySelector('#qrcode'), { useCORS: true })
            .then((canvas) => {
                download(canvas.toDataURL('image/png'), `QRcode.png`);
                const { toastTip } = GetParamsData()
                toastTip.success('Lưu Mã Thành Công', 2);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    render() {


        return (
            <>
                <NextStepCon
                    // 是否存款提示
                    PayModal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText, onCancel } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                isColumn={true}
                                okText={okText}
                                onOk={onChange}
                                onCancel={onCancel}
                            />
                        )
                    }}
                    // 无法存款提示
                    Modal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText={okText}
                                onOk={onChange}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    // 图片错误提示
                    FileModal={(propCon) => {
                        const { modalVisible, title, msg, onChange, okText } = propCon
                        return (
                            <Modal
                                className='modalTips'
                                visible={modalVisible}
                                title={title}
                                onlyOkBtn={true}
                                okText={okText}
                                onOk={onChange}
                            >
                                <>
                                    <div className='titleIcon'>
                                        <span className='warningIcon imgIcon' />
                                    </div>
                                    <p className="intro">{msg}</p>
                                </>
                            </Modal>
                        )
                    }}
                    NextStep={(propCon) => {
                        const {
                            MethodsActive,
                            DepositPayments,
                            DepositMoneyStatus,
                            backClick,
                            onChange,
                        } = propCon

                        const { uniqueAmount, returnedBankDetails, qrDeepLink } = DepositPayments || {}
                        const { accountHolderName, accountNumber } = returnedBankDetails || {}
                        const { money } = DepositMoneyStatus || {}
                        return (
                            <div className='nextModal'>
                                <div className='nextModalCenter'>
                                    <TipsView msg={'Giao dịch bắt đầu: 07-02-2022 15:34:02 (GMT+8) Vui lòng hoàn tất giao dịch của bạn trong vòng 30 phút, nếu không hệ thống sẽ tự động hủy giao dịch.'} />
                                    <div className='viewArea'>
                                        <p className='inextTitle'>Thông tin tiền gửi của bạn:</p>

                                        <div className='amount'>
                                            <span className='amountTitle'>Số Tiền Gửi (1=1,000)</span>
                                            <span className='amountValue'>{numberWithCommas(uniqueAmount != 0 && uniqueAmount || money)} đ</span>
                                        </div>


                                        <div className='tipsGray'>
                                            Sau khi giao dịch thành công, số tiền <span>{numberWithCommas(money * 1000)}</span> sẽ được cập nhật vào tài khoản của bạn.
                                        </div>
                                    </div>
                                    <div className='viewArea'>
                                        <p className='inextTitle'>Ngân Hàng FUN88:</p>
                                        {/* qrcode */}
                                        <p className='promptMsg'>Quét mã QR để gửi tiền và lưu ý mã QR này chỉ sử dụng được 1 lần duy nhất.</p>
                                        {/* qrcode */}
                                        <div className='QD-qrCode' onClick={this.viewShots}>
                                            <div className='QD-qrCode-border'>
                                                {/* <QRCodeView deepLink={'qrDeepLink'} /> */}
                                                <img id='qrcode' src={qrDeepLink} alt='' />
                                            </div>
                                            <div className='DQ-download' onClick={this.downloadShareImage}>
                                                Lưu Mã QR
                                            </div>
                                        </div>
                                        <div className='borders' />
                                        <div className='line-distance'></div>
                                        {/* 持有人姓名 */}
                                        <CopyView
                                            copyTitle={'Tên Người Nhận'}
                                            copyValue={accountHolderName}
                                            copyType={'accountHolderName'}
                                        />

                                        {/* 卡号 */}
                                        <CopyView
                                            copyTitle={'Tên Người Nhận'}
                                            copyValue={accountNumber}
                                            copyType={'accountNumber'}
                                        />
                                    </div>
                                    {/* 上传图片 */}
                                    <div className='viewArea'>
                                        <div style={{ paddingTop: 20 }}>
                                            <UploadFile />
                                        </div>
                                    </div>

                                    <SubmitBtn
                                        onPress={onChange}
                                        submitBtnItem={'Tôi Đã Gửi Tiền Thành Công'}
                                    />
                                </div>
                            </div>
                        )
                    }}

                />
            </>
        );
    }
}

export default NextStep



